import { Component } from 'react'
import { reportProblem } from '../utils/problems'

// A page that throws while drawing shows this instead of a blank screen,
// and the server is told (utils/problems.js). Moving to another page
// (resetKey changes) tries again.
export default class ErrorBoundary extends Component {
  state = { failed: false }

  static getDerivedStateFromError() {
    return { failed: true }
  }

  componentDidCatch(error, info) {
    reportProblem({
      message: (error && error.message) || String(error),
      detail: `${(error && error.stack) || ''}\n${(info && info.componentStack) || ''}`,
    })
  }

  componentDidUpdate(prev) {
    if (this.state.failed && prev.resetKey !== this.props.resetKey) this.setState({ failed: false })
  }

  render() {
    if (!this.state.failed) return this.props.children
    return (
      <div className="page-problem" role="alert">
        <h2>This page hit a problem</h2>
        <p>We’ve been told about it. Reloading usually clears it; if it keeps happening, try again later.</p>
        <button type="button" className="ci-btn ci-btn-primary" onClick={() => window.location.reload()}>Reload</button>
      </div>
    )
  }
}
